import React from 'react'
import { PageProps } from '@/types'
import surveyIllustration from '@/assets/images/survey_illustration.svg'
import EmailContactInput from '@/components/Survey/EmailContactInput'
import PhoneContactInput from '@/components/Survey/PhoneContactInput'
import { useContactForm } from '@/hooks/useContactForm'

interface ThankYouProps extends PageProps {
  answer_id?: string
  survey_set: {
    id: number
    hashid: string
  }
}

const ThankYou: React.FC<ThankYouProps> = ({ answer_id, survey_set }) => {
  const {
    contactPreferences,
    setContactPreferences,
    formData,
    isSubmitting,
    errors,
    handleEmailChange,
    handlePhoneChange,
    handleSubmit,
    isValidForm
  } = useContactForm(answer_id)

  return (
    <div className="bg-blue-50 h-screen">
      <div className="flex items-center px-4">
        <div className="bg-white rounded-lg shadow-lg p-8 mx-auto text-center max-w-lg w-full my-20">
          <h1 className="text-2xl font-bold text-gray-800 mb-6">¡Tus respuestas fueron enviadas!</h1>

          <img src={surveyIllustration} alt="" className="w-full max-w-xs mx-auto my-8" />

          <h2 className="text-xl font-semibold text-gray-700 mb-6">¡Gracias por participar!</h2>

          <div className="text-left space-y-6">
            <p className="text-gray-700 text-sm mb-4">
              Selecciona cómo prefieres que te contactemos para ayudar a mejorar este servicio digital:
            </p>

            <form onSubmit={e => handleSubmit(e, survey_set.hashid)} className="space-y-6">
              <div className="space-y-2">
                <EmailContactInput
                  isChecked={contactPreferences.wantsEmailContact}
                  onCheckboxChange={e =>
                    setContactPreferences(prev => ({
                      ...prev,
                      wantsEmailContact: e.target.checked
                    }))
                  }
                  email={formData.email}
                  onEmailChange={handleEmailChange}
                  isSubmitting={isSubmitting}
                  error={errors.email}
                />
              </div>

              <div className="space-y-2">
                <PhoneContactInput
                  isChecked={contactPreferences.wantsPhoneContact}
                  onCheckboxChange={e =>
                    setContactPreferences(prev => ({
                      ...prev,
                      wantsPhoneContact: e.target.checked
                    }))
                  }
                  phone={formData.phone}
                  onPhoneChange={handlePhoneChange}
                  isSubmitting={isSubmitting}
                  error={errors.phone}
                />
              </div>

              {errors.submit && <p className="text-red-500 text-sm text-center">{errors.submit}</p>}

              <div className="flex justify-end space-x-4">
                {contactPreferences.wantsEmailContact || contactPreferences.wantsPhoneContact ? (
                  <button
                    type="submit"
                    disabled={!isValidForm() || isSubmitting}
                    className={`px-6 py-3 rounded-lg font-medium transition-colors ${
                      isValidForm() && !isSubmitting
                        ? 'bg-blue-600 text-white hover:bg-blue-700 cursor-pointer'
                        : 'bg-gray-400 text-gray-200 cursor-not-allowed'
                    }`}
                  >
                    {isSubmitting ? 'Enviando...' : 'Enviar'}
                  </button>
                ) : (
                  <button
                    type="button"
                    onClick={() => (window.location.href = `/encuestas/${survey_set.hashid}`)}
                    className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 cursor-pointer font-medium"
                  >
                    Finalizar
                  </button>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default React.memo(ThankYou)
